import { Button, ButtonProps } from '@mui/material';

type Props = ButtonProps;

export function ActionButton({ children, sx, onClick, ...props }: Props) {
  return (
    <Button
      {...props}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
      sx={{
        padding: '4px',
        width: '22px',
        height: '22px',
        minWidth: '22px',
        boxSizing: 'border-box',
        borderRadius: '4px',
        border: '1px solid var(--Gray-100, #F2F4F7)',
        '&:focus': {
          border: '1px solid var(--Gray-100, #F2F4F7)',
          outline: 'none',
        },
        '&:active': {
          border: '1px solid var(--Gray-100, #F2F4F7)',
        },
        ...sx,
      }}
    >
      {children}
    </Button>
  );
}
